import { featuredCategories } from "@/mocks/categories";

const categoryImages: Record<string, string> = {
  Shoes: "https://readdy.ai/api/search-image?query=Close%20up%20shot%20of%20premium%20white%20leather%20sneakers%20on%20light%20grey%20concrete%20surface%20with%20green%20plant%20shadows%2C%20bright%20natural%20light%2C%20minimal%20composition%2C%20clean%20product%20photography%20style%20with%20soft%20shadows&width=600&height=400&seq=cat-card-shoes-v2&orientation=landscape",
  "Hoodies / Sweaters": "https://readdy.ai/api/search-image?query=Cozy%20oversized%20pastel%20hoodie%20draped%20over%20wooden%20chair%20in%20bright%20airy%20room%2C%20morning%20sunlight%20streaming%20through%20window%2C%20soft%20cream%20walls%2C%20warm%20lifestyle%20fashion%20photography%20with%20gentle%20shadows&width=600&height=400&seq=cat-card-hoodies-v2&orientation=landscape",
  "T-Shirts": "https://readdy.ai/api/search-image?query=Stack%20of%20folded%20colorful%20graphic%20t-shirts%20on%20white%20marble%20surface%20organized%20by%20color%20gradient%2C%20overhead%20shot%2C%20clean%20bright%20aesthetic%2C%20minimalist%20product%20photography&width=600&height=400&seq=cat-card-tshirts-v2&orientation=landscape",
  Jackets: "https://readdy.ai/api/search-image?query=Vintage%20denim%20jacket%20hanging%20on%20minimalist%20wooden%20hanger%20against%20warm%20beige%20wall%2C%20soft%20side%20lighting%2C%20editorial%20fashion%20photography%2C%20clean%20simple%20composition&width=600&height=400&seq=cat-card-jackets-v2&orientation=landscape",
  Jersey: "https://readdy.ai/api/search-image?query=Sports%20jersey%20laid%20flat%20on%20dark%20textured%20concrete%20surface%20with%20dramatic%20side%20lighting%2C%20athletic%20aesthetic%2C%20bold%20colors%20popping%20against%20dark%20background%2C%20editorial%20sports%20photography&width=600&height=400&seq=cat-card-jersey-v2&orientation=landscape",
  Accessories: "https://readdy.ai/api/search-image?query=Assortment%20of%20minimalist%20watches%20and%20jewelry%20pieces%20arranged%20on%20light%20travertine%20stone%20surface%2C%20gold%20and%20silver%20tones%2C%20soft%20natural%20lighting%2C%20elegant%20product%20photography&width=600&height=400&seq=cat-card-accessories-v2&orientation=landscape",
};

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-accent-100 text-accent-800 uppercase tracking-wider mb-4">
            Browse Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Featured{" "}
            <span className="text-primary-500">Spreadsheet Categories</span>
          </h2>
          <p className="mt-3 text-foreground-600 max-w-[560px] mx-auto text-sm md:text-base">
            Explore our organized pandabuy spreadsheet database — every category handpicked and updated regularly
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 cursor-pointer transition-all duration-300 hover:translate-y-[-4px]"
            >
              <div className="relative h-[180px] md:h-[200px] overflow-hidden">
                <img
                  src={categoryImages[cat.name] || categoryImages.Shoes}
                  alt={`${cat.name} pandabuy spreadsheet finds`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase whitespace-nowrap ${
                    cat.badge === "HOT"
                      ? "bg-accent-500 text-background-50"
                      : cat.badge === "NEW"
                      ? "bg-primary-500 text-background-50"
                      : cat.badge === "TRENDING"
                      ? "bg-secondary-600 text-background-50"
                      : "bg-foreground-600 text-background-50"
                  }`}>
                    {cat.badge}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                    <i className={`${cat.icon} text-primary-500 text-sm`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-950 text-base whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  Browse Items
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}